module.exports = __webpack_public_path__ + "static/media/12.b48f0e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/12.png
// module id = 183
// module chunks = 0